'use strict';

var _classCallCheck = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _notificationTypes = require('../constants/notificationTypes');

var _notificationTypes2 = _interopRequireDefault(_notificationTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Usage:
 * const isNotification = new IsNotification(notifType);
 * (isNotification.kycNotPassed || isNotification.riskScreenNoAnswer) && doingSomething()
 */


var IsNotification =
/**
 * @param type - String
 */
function IsNotification(type) {
  _classCallCheck(this, IsNotification);

  this.kycNotPassed = type === _notificationTypes2.default.KYC_NOT_PASSED;
  this.riskScreenNoAnswer = type === _notificationTypes2.default.RISK_SCREEN_NO_ANSWER;
  this.userProfileUpdate = type === _notificationTypes2.default.USER_PROFILE_UPDATE;
  this.userDataChanged = type === _notificationTypes2.default.USER_DATA_CHANGED;
  this.spAdminApplied = type === _notificationTypes2.default.SP_ADMIN_APPLIED;
  this.passedKyc = type === _notificationTypes2.default.PASSED_KYC;
  this.mangopayAccountCreated = type === _notificationTypes2.default.MANGOPAY_ACCOUNT_CREATED;
  this.spUsersCreationSuccessful = type === _notificationTypes2.default.SP_USERS_CREATION_SUCCESSFUL;
  this.spUsersCreationFailed = type === _notificationTypes2.default.SP_USERS_CREATION_FAILED;
  this.kycDocumentValidated = type === _notificationTypes2.default.KYC_DOCUMENT_VALIDATED;
  this.kycDocumentRefused = type === _notificationTypes2.default.KYC_DOCUMENT_REFUSED;
  this.mangopayAccountNotCreated = type === _notificationTypes2.default.MANGOPAY_ACCOUNT_NOT_CREATED;
  this.projectNdaSigned = type === _notificationTypes2.default.PROJECT_NDA_SIGNED;
  this.projectPublishedForReview = type === _notificationTypes2.default.PROJECT_PUBLISHED_FOR_REVIEW;
  this.projectPublished = type === _notificationTypes2.default.PROJECT_PUBLISHED;
  this.projectRejected = type === _notificationTypes2.default.PROJECT_REJECTED;
  this.projectApproved = type === _notificationTypes2.default.PROJECT_APPROVED;
  this.projectInvested = type === _notificationTypes2.default.PROJECT_INVESTED;
  this.projectFullyInvested = type === _notificationTypes2.default.PROJECT_FULLY_INVESTED;
  this.projectNotReceivedTargetAmount = type === _notificationTypes2.default.PROJECT_NOT_RECEIVED_TARGET_AMOUNT;
  this.projectNotReceivedTargetAmountForInvestor = type === _notificationTypes2.default.PROJECT_NOT_RECEIVED_TARGET_AMOUNT_FOR_INVESTOR;
  this.payInTransactionSuccessful = type === _notificationTypes2.default.PAY_IN_TRANSACTION_SUCCESSFUL;
  this.payInTransactionFailed = type === _notificationTypes2.default.PAY_IN_TRANSACTION_FAILED;
  this.payOutTransactionSuccessful = type === _notificationTypes2.default.PAY_OUT_TRANSACTION_SUCCESSFUL;
  this.payOutTransactionFailed = type === _notificationTypes2.default.PAY_OUT_TRANSACTION_FAILED;
  this.dataRoomAccessRequested = type === _notificationTypes2.default.DATA_ROOM_ACCESS_REQUESTED;
  this.dataRoomAccessGranted = type === _notificationTypes2.default.DATA_ROOM_ACCESS_GRANTED;
  this.firstTimeView = type === _notificationTypes2.default.FIRST_TIME_VIEW;
  this.projectInvestedForIssuer = type === _notificationTypes2.default.PROJECT_INVESTED_FOR_ISSUER;
  this.spSubscriptionActivated = type === _notificationTypes2.default.SP_SUBSCRIPTION_ACTIVATED;
};

exports.default = IsNotification;